/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdSelect, MdSelectTrigger, MD_SELECT_SCROLL_STRATEGY_PROVIDER} from './select';
import {MdCommonModule, MdOptionModule} from '@angular/material/core';
import {OverlayModule} from '@angular/cdk/overlay';
export class MdSelectModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OverlayModule,
    MdOptionModule,
    MdCommonModule,
  ],
  exports: [MdSelect, MdSelectTrigger, MdOptionModule, MdCommonModule],
  declarations: [MdSelect, MdSelectTrigger],
  providers: [MD_SELECT_SCROLL_STRATEGY_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSelectModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
